import script from "./layout.vue?vue&type=script&setup=true&lang=js"
export * from "./layout.vue?vue&type=script&setup=true&lang=js"

import "./layout.vue?vue&type=style&index=0&id=f63b0aae&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\code\\Dataleading3.0\\dataleading\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f63b0aae"]])

export default __exports__